const chartTypes = [
  'Intro',
  'ExecutiveSummary',
  'Fees',
  'Expenses',
  'FinancialPerformanceYTD',
  'YearlyFinancialPerformance',
  'BalanceSheet',
  'CashFlow',
  'Debtors',
  'ProjectPerformance',
  'WorkInHand',
  'Opportunities',
  'WorkGenerated',
  'FeeProjection',
  'ProjectedFinancialPerformance',
  'ProjectedCashFlow',
  'People',
  'KPI',
];

const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const fMonths = [6, 7, 8, 9, 10, 11, 0, 1, 2, 3, 4, 5];
const enMonths = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];
const daysRangeKeys = [
  'Outstanding30Days',
  'Outstanding60Days',
  'Outstanding90Days',
  'Outstanding120Days',
  'Outstanding120PlusDays',
];
const debtorKeyTextMap = {
  Outstanding30Days: '0-30',
  Outstanding60Days: '31-60',
  Outstanding90Days: '61-90',
  Outstanding120Days: '91-120',
  Outstanding120PlusDays: '120+',
  Total: 'All',
};
const debtorColors = {
  Outstanding30Days: '#cfe8ae',
  Outstanding60Days: '#eac0bd',
  Outstanding90Days: '#f37263',
  Outstanding120Days: '#d63128',
  Outstanding120PlusDays: '#be1e2d',
  Total: '#919698',
};
const daysRanges = {
  0: {
    key: 0,
    daysRange: 'Outstanding30Days',
    text: '0-30',
    color: '#cfe8ae',
  },
  1: {
    key: 1,
    daysRange: 'Outstanding60Days',
    text: '31-60',
    color: '#eac0bd',
  },
  2: {
    key: 2,
    daysRange: 'Outstanding90Days',
    text: '61-90',
    color: '#f37263',
  },
  3: {
    key: 3,
    daysRange: 'Outstanding120Days',
    text: '91-120',
    color: '#d63128',
  },
  4: {
    key: 4,
    daysRange: 'Outstanding120PlusDays',
    text: '120+',
    color: '#be1e2d',
  },
  5: {
    key: 5,
    daysRange: 'Total',
    text: 'Total',
    color: '#919698',
  },
};

const borderHoverColor = '#939393';
const minusActiveColor = '#be1e2d';
const minusDisableColor = '#be1e2d';
const positiveActiveColor = '#8dc63f';
const positiveDisableColor = '#8dc63f';
const negativeActiveColor = '#919698';
const negativeDisableColor = '#919698';
const labelColor = '#000000';
const activeLabelColor = '#316ac5';

const ITEM_HEIGHT = 30;
const ITEM_PADDING_TOP = 5;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 15 + ITEM_PADDING_TOP,
      width: 130,
    },
  },
};

const barHeight = 30;
const barThinHeight = 25;

const formatedStyle = (width, size, mar = 0, bolds = 0, cursors = '') => {
  return {
    width: `${width}px`,
    fontSize: `${size}px`,
    margin: `${mar}`,
    alignItems: 'center',
    fontWeight: `${bolds === 1 ? 'bold' : 'normal'}`,
    cursor: `${cursors}`,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
};
const b_formatedStyle = (width, size, mar = 0, bolds = 0, cursors = '') => {
  return {
    width: `${width}px`,
    fontSize: `${size}px`,
    margin: `${mar}`,
    paddingTop: '5px',
    fontWeight: `${bolds === 1 ? 'bold' : 'bold'}`,
    cursor: `${cursors}`,
  };
};

const subtitle_inv = {
  backgroundColor: '#e0ebd2',
};

const ship = (maxHeight) => {
  return {
    maxHeight: `${maxHeight}px`,
    overflowY: 'auto',
    borderBottom: 'solid 1px darkgray',
    borderTop: 'solid 1px darkgray',
    fontSize: '12px',
  };
};

const shipP = (maxHeight) => {
  return {
    maxHeight: `${maxHeight}vh`,
    overflowY: 'auto',
    borderBottom: 'solid 1px darkgray',
    borderTop: 'solid 1px darkgray',
    fontSize: '12px',
  };
};

const axis = {
  height: barHeight,
};

const thinAxis = {
  height: barThinHeight,
};

const tooltip = {
  minWidth: 40,
  backgroundColor: 'white',
  color: 'black',
};

const item = {
  height: barHeight,
  margin: 0,
  paddingTop: '7px',
  // paddingLeft: '5px',
};

const thinItem = {
  height: barThinHeight + 'px',
  margin: 0,
  lineHeight: barThinHeight + 'px',
  // paddingLeft: '5px',
};

const mediumItem = {
  height: barThinHeight + 'px',
  margin: 0,
  lineHeight: barThinHeight + 'px',
  paddingLeft: '5px',
  fontSize: '12px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const empty = (height) => {
  return {
    width: '100%',
    height: `${height}px`,
    lineHeight: `${height}px`,
    textAlign: 'center',
  };
};

export {
  chartTypes,
  months,
  fMonths,
  enMonths,
  daysRangeKeys,
  debtorKeyTextMap,
  debtorColors,
  daysRanges,
  borderHoverColor,
  positiveActiveColor,
  positiveDisableColor,
  negativeActiveColor,
  negativeDisableColor,
  labelColor,
  activeLabelColor,
  minusActiveColor,
  minusDisableColor,
  subtitle_inv,
  formatedStyle,
  b_formatedStyle,
  MenuProps,
  barHeight,
  barThinHeight,
  ship,
  shipP,
  axis,
  thinAxis,
  tooltip,
  item,
  thinItem,
  mediumItem,
  empty,
};
